export default "/assets/website/images/store-3.jpeg?7cbe5ae1e75243fcfda57237f1e01fa3";